export const getIdMap = (items) => items.reduce((all, item) => {
  all[item.id] = item
  return all
}, {})